import React from "react";
import CheckoutDetailsSkeleton from "./CheckoutDetailsSkeleton";

const CheckoutSkeleton: React.FC = () => {
  return (
    <section className="section relative text-white py-10 max-sm:p-4 blue-bg-dots min-h-[calc(100vh-260px)]">
      <div className="container max-sm:px-0">
        <h2 className="text-lightBlue text-6xl max-md:text-4xl max-sm:text-2xl text-start mb-8 max-sm:mb-3 flex gap-3">
          <span>checkout as a</span>{" "}
          <div className="skeleton w-48 max-sm:w-32 h-16 max-sm:h-8"></div>
        </h2>

        <CheckoutDetailsSkeleton />
      </div>
    </section>
  );
};

export default CheckoutSkeleton;
